const HIDDEN_CSS_CLASS = 'js-faq__item--hidden';
const PAGE_SIZE = 5;
/**
 * infinite 'loader' of FAQ items (they are in DOM but visually hidden)
 *
 * items are also an accordion toggle but that is native now
 */
class FAQList extends HTMLElement {
  constructor() {
    super();

    // selector is child btn as (currently) we dont has class as an arg on the button snippet
    this.loadNext = this.querySelector('.js-load-more');
    this.itemList = this.querySelector('.faq__item-list');

    this.loadNext?.addEventListener('click', this.onLoadNext.bind(this));
  }

  onLoadNext() {
    const remaining = Array.from(this.querySelectorAll(`.${HIDDEN_CSS_CLASS}`));
    const items = remaining.slice(0, PAGE_SIZE);

    items.forEach((item) => {
      item.classList.remove(HIDDEN_CSS_CLASS);
    });

    // load more is not needed if we have hit the end
    if (items.length >= remaining.length) {
      this.loadNext.classList.add(HIDDEN_CSS_CLASS);
      items.at(-1).focus();
    }

    this.itemList.scrollTo({
      left: 0,
      top: this.itemList.scrollHeight,
      behavior: 'smooth',
    });
  }
}

customElements.define('faq-list', FAQList);
